import { connect } from 'react-redux';

import PriceNotice from './PriceNotice';
import type { Direction } from './types';

import { getHotelLinkWithRequestId } from '../../../../store/selectors/hotel';
import {
  directionPriceChangeSelector,
  isPriceChangedSignificantlySelector,
} from '../../../../store/selectors/order';

const mapStateToProps = (state) => ({
  direction: directionPriceChangeSelector(state) as Direction,
  isPriceChangedSignificantly: isPriceChangedSignificantlySelector(state),
  hotelLink: getHotelLinkWithRequestId(state),
});

export default connect(mapStateToProps)(PriceNotice);
